import React from 'react';
import { useLocation } from 'react-router-dom';
import { Alert, Container, Grid, Typography, Link, Image } from '@iho-design-system/Loader';

import { NavLink } from "react-router-dom";

/*
- component
*/
import Tabs from '../components/profile/Tabs';
import PaginationLeftSVG from './../assets/images/icons/pagination-left.svg';
import BaseInfo from '../components/profile/base-info';
import  BossInfo  from '../components/profile/boss-info';
import  ChangePass from '../components/profile/change-pass';
import OfficerInfo  from '../components/profile/officer-info';
import UploadLicense from '../components/profile/upload-license';

/*
    - api
*/
import getAPI from './../api/get';



export default function Profile() {
    let userRegisterType = localStorage.getItem('type');
    const [typeUser, setTypeUser] = React.useState('');

    React.useEffect(() => {
        const fetchData = async () => {
            
       
          let userTypeParameters = {
            ctrl: 'UserProfile',
            method: 'GetUserProfile',
            query: ''
          }
        let response = await getAPI(userTypeParameters);
         if(response.status == 200){
            localStorage.setItem('userType',response.data.userType);
            switch (response.data.userType) {
                case 1:
                    setTypeUser('آژانسی');
                    break;
                    case 3:
                        setTypeUser('شخص حقیقی');
                    break;
                    case 4:
                        setTypeUser('نماینده') ;
                    break;
                    case 2:
                        setTypeUser( 'سازمان');
                    break;
            
                default:
                    break;
            }
        
            
         }
        }
        fetchData();
      }, []);
      


   


    const location = useLocation();
    let pageTab = '';
    switch (location.pathname) {
        
        case '/profile/base-info':
            pageTab = 'base';
            break;
        case '/profile/boss-info':
            pageTab = 'boss';
            break;
        case '/profile/officer-info':
            pageTab = 'officer';
            break;
        case '/profile/upload-license':
            pageTab = 'upload';
            break;
        case '/profile/change-pass':
            pageTab = 'pass';
            break;

        default:
            break;
    }

    return (
        <Container
            size='lg'>
            <Grid>
                <Grid.Wrapper ms={{
                    marginTop: '50px',
                }}>
                    <Grid.Item
                        size='col-6'>
                        <Typography
                            className={`d-block`}
                            component='strong'>
                            پروفایل کاربری
                        </Typography>

                    </Grid.Item>
                    <Grid.Item
                        className={`text-left`}
                        size='col-6'>
                        <NavLink
                             to='/dashboard/'
                            className="d-flex text-primary float-left align-item-center">
                            بازگشت به داشبورد
                            <Image
                                ms={{
                                    width: '30px !important',
                                    height: '30px !important',
                                }}
                                src={PaginationLeftSVG} />
                        </NavLink>

                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
            <Tabs />

            {/* content tabs */}
            <Grid>
                <Grid.Wrapper>
                    <Grid.Item
                        size='col-12'>

                    </Grid.Item>
                    <Grid.Item
                        className={`pr-0 pl-0`}
                        size='col-12'>
                        {pageTab === 'base'   &&
                           <BaseInfo typeUser={typeUser} />
                        }
                        {pageTab === 'boss'   &&
                           <BossInfo typeUser={typeUser} />
                        }
                        {pageTab === 'officer' &&
                          <OfficerInfo typeUser={typeUser} />
                        }
                        {pageTab === 'upload' &&
                           <UploadLicense typeUser={typeUser} />
                        }
                        {pageTab === 'pass' &&
                           <ChangePass typeUser={typeUser} />
                        }
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>




        </Container>
    );
}
